import React from 'react';
import { TimePicker } from 'antd';
import dayjs from 'dayjs';
import TimePickerCss from './TimePickerCss.css'

function TimePickerComponent({ onChange }) {

    const handleChange = (times) => {

        if (times && onChange) {
            const [startTime, endTime] = times;

            // // Convert time to local time zone and format to 12-hour format with AM/PM
            const formattedStartTime = dayjs(startTime).format('hh:mm A');  // Convert to 12-hour format
            const formattedEndTime = dayjs(endTime).format('hh:mm A');      // Convert to 12-hour format

            // // Pass back to parent component
            onChange([startTime, endTime], [formattedStartTime, formattedEndTime]);
            // onChange([startTime, endTime]);
        }
    };

    return (
        <>
            <TimePicker.RangePicker
                showTime
                format="hh:mm A"  // 12-hour format with AM/PM
                onChange={handleChange}
                placeholder={['Start Time', 'End Time']}
                // className="time-picker "
                className="time-picker text-white bg-gray-600 hover:bg-gray-600 border-0 p-2 font-poppins"
            />
        </>
    );
}

export default TimePickerComponent;


